import store from "@/store/index";
import * as grpcWeb from "grpc-web";
import router from "@/router/index";

// サーバのエラーによって、アラートモーダル上の文言を変更したい場合は、ここに定数を追加し、その分岐を実装すること
const notBeAbleToSendScoutMessage = "not be able to send scout message";

export const handleGrpcError = async (error: grpcWeb.RpcError) => {
  switch (error.code) {
    case grpcWeb.StatusCode.INVALID_ARGUMENT:
      updateGrpcError(error.code, error.message);
      if (error.message === notBeAbleToSendScoutMessage) {
        setHasScoutCanNotSendError();
        break;
      }

      showAlert("不正なパラメータです", error.message);
      break;
    case grpcWeb.StatusCode.INTERNAL:
      showAlert(
        "通信に失敗しました",
        "サーバーでエラーが発生しました。しばらくしてからご確認ください。"
      );
      break;
    case grpcWeb.StatusCode.DEADLINE_EXCEEDED:
      showAlert(
        "通信に失敗しました",
        "サーバーからの応答がありません。しばらくしてからご確認ください。"
      );
      break;
    case grpcWeb.StatusCode.NOT_FOUND:
    case grpcWeb.StatusCode.PERMISSION_DENIED:
      updateGrpcError(error.code, error.message);
      break;
    case grpcWeb.StatusCode.UNAUTHENTICATED:
      // 明示的にサインアウトしてログイン画面に遷移させる
      // NOTE: awaitでsignOut処理が完了されるまで待たないとNavigation Guardに引っかかる。
      await store.dispatch("domains/user/signOut");
      router
        .push({
          name: "SignIn",
          query: { isLoggedOut: "true" }
        })
        .catch(err => err); // リダイレクトされた通知だけなので、console.errorを表示しないで、スキップする。sentryにも通知しない
      showAlert("認証に失敗しました", "再度ログインしてください");
      break;
    default:
      showAlert(
        "通信に失敗しました",
        "インターネットの接続を確認して再読み込みを実行してください"
      );
      break;
  }
};

const showAlert = (title: string, message: string) => {
  store.commit("common/updateAlertView", {
    isVisible: true,
    title: title,
    message: message
  });
};

const updateGrpcError = (code: grpcWeb.StatusCode, message: string) => {
  store.commit("common/updateGrpcError", {
    code: code,
    message: message
  });
};

const setHasScoutCanNotSendError = () => {
  store.commit("domains/scout/setHasScoutCanNotSendError");
};
